import React from 'react';
import useENotification from '../../../../../hooks/eNotification';

const path = '../oldPages/e-notification/active-template/index.html';

function ENotificationActiveTemplate() {
  const { iframeRef } = useENotification();

  return <iframe ref={iframeRef} title="e-notification-active-template" src={path} width="100%" height="500px" />;
}

export default ENotificationActiveTemplate;
